// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"iW","loading":"iX","b":"iY","errorMsg":"iZ","loadingMsg":"i0","successMsg":"i1","hideLoadingMsg":"i2","completed":"i3","a":"i4","kidsGreen":"i5"};